/* eslint-disable import/prefer-default-export */
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { deleteDashboard } from 'features/dashboard/asyncThunks'
import { selectIsDashboardDeleting } from 'features/dashboardInfo/selectors'

interface UseDeleteDashboardProps {
  dashboardId?: string
}

interface UseDeleteDashboardResult {
  handleDelete: () => Promise<void>
  isDeleting: boolean
}

export const useDeleteDashboard = ({
  dashboardId
}: UseDeleteDashboardProps): UseDeleteDashboardResult => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const isDeleting = useAppSelector(selectIsDashboardDeleting)

  const handleDelete = useCallback(async () => {
    if (!dashboardId) {
      return
    }

    try {
      await dispatch(deleteDashboard(Number(dashboardId))).unwrap()
      navigate('/dashboard/home')
    } catch (err) {
      console.error('Error deleting dashboard:', err)
    }
  }, [dashboardId, dispatch, navigate])

  return {
    handleDelete,
    isDeleting
  }
}
